import { ActionTree, GetterTree, MutationTree, Module } from "vuex";
import { action, createModule, mutation } from "vuex-class-component";
import rest from "@/rest";
import { TtsModelVm, TtsVoiceVm } from "@/interfaces/TtsModelVm";
import { CustomizationVm } from "@/interfaces/CustomizationVm";

const VuexModule = createModule({
  strict: false,
  namespaced: "customization",
});

export class Customization extends VuexModule {
  _settings: CustomizationVm | null = null;
  _ttsModels: TtsModelVm[] = [];

  // getters
  get customizationSettings(): CustomizationVm | null {
    return this._settings;
  }

  get ttsStandardVoices(): { [key: string]: TtsVoiceVm[]; } | null {
    let selectedTtsStandardModel = this._settings?.standardTtsModel;
    // if (!selectedTtsStandardModel)
    //   return {};
    let standardTtsModel = this._ttsModels.find(m => m.model === selectedTtsStandardModel);
    if (!standardTtsModel)
      return {};
    return standardTtsModel.voices;
  }

  get ttsPodcastVoices(): { [key: string]: TtsVoiceVm[]; } | null {
    let selectedTtsPodcastModel = this._settings?.podcastTtsModel;
    // if (!selectedTtsPodcastModel)
    //   return {};
    let podcastTtsModel = this._ttsModels.find(m => m.model === selectedTtsPodcastModel);
    if (!podcastTtsModel)
      return {};
    return podcastTtsModel.voices;
  }

  @action async loadCustomizationSettings() {
    // TODO: Set default values on startup to make sure the app shows up right also if there are connection problems

    let settings: CustomizationVm = await rest.url("auth/getCustomizationSettings").get();
    if (settings != null)
      this.setCustomizationSettings(settings);

    let ttsModels: TtsModelVm[] = await rest.url("auth/getTtsSelections").get();
    if (ttsModels != null)
      this.setTtsModels(ttsModels);

    // console.log("CustomizationSettings loaded");
  }

  @action async saveCustomizationSettings(settings: CustomizationVm) {
    let values: CustomizationVm = await rest.url("admin/saveCustomizationSettings").post(settings);
    this.setCustomizationSettings(values);
  }

  // mutations
  @mutation setCustomizationSettings(settings: CustomizationVm | null) {
    this._settings = settings;
  }
  @mutation setTtsModels(ttsModels: TtsModelVm[]) {
    this._ttsModels = ttsModels;
  }
};